// extracted by mini-css-extract-plugin
export var wordContainer = "_ra-0";